import { Helmet } from 'react-helmet-async'
import PageLayout from '../components/layout/PageLayout.jsx'
import SectionHeading from '../components/ui/SectionHeading.jsx'
import { products } from '../data/products.js'
import { motion } from 'framer-motion'
import { useMemo, useState } from 'react'

export default function Products() {
  const tabs = useMemo(
    () => [
      { key: 'Anti Cancer With CAS', label: 'Anti Cancer With CAS' },
      { key: 'Common Drugs With CAS', label: 'Common Drugs With CAS' },
    ],
    []
  )

  const [activeTab, setActiveTab] = useState(tabs[0].key)

  const rows = useMemo(() => {
    return products.filter((p) => p.category === activeTab)
  }, [activeTab])

  return (
    <PageLayout>
      <Helmet>
        <title>Products | Ritik Medicare Pvt. Ltd.</title>
        <meta
          name="description"
          content="Explore Ritik Medicare products. Anti Cancer With CAS and Common Drugs With CAS lists with CAS numbers."
        />
      </Helmet>

      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:py-16">
          <SectionHeading
            eyebrow="Products"
            title="Pharmaceutical-grade offerings"
            subtitle="Anti Cancer With CAS and Common Drugs With CAS."
          />

          <div className="mt-10">
            <div className="flex flex-wrap gap-2 justify-center">
              {tabs.map((t) => {
                const isActive = t.key === activeTab
                return (
                  <button
                    key={t.key}
                    type="button"
                    onClick={() => setActiveTab(t.key)}
                    className={
                      'rounded-2xl px-4 py-2 text-sm sm:text-[15px] font-semibold border transition ' +
                      (isActive
                        ? 'bg-brand-primary text-white border-brand-primary'
                        : 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50')
                    }
                  >
                    {t.label}
                  </button>
                )
              })}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35 }}
              className="mt-6 rounded-3xl border border-slate-200 bg-white p-4 sm:p-6"
            >
              {rows.length === 0 ? (
                <div className="py-10 text-center text-sm text-slate-600">No products found.</div>
              ) : (
                <>
                  <div className="overflow-x-auto">
                    <table className="min-w-full text-left">
                      <thead>
                        <tr className="border-b border-slate-200">
                          <th className="py-3 pr-4 text-sm font-extrabold text-slate-900">No.</th>
                          <th className="py-3 pr-4 text-sm font-extrabold text-slate-900">Product Name</th>
                          <th className="py-3 text-sm font-extrabold text-slate-900">CAS Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((p, idx) => (
                          <tr key={p.id} className="border-b border-slate-100 last:border-b-0">
                            <td className="py-2.5 pr-4 text-sm font-semibold text-slate-700">{idx + 1}</td>
                            <td className="py-2.5 pr-4 text-sm font-semibold text-slate-900">{p.name}</td>
                            <td className="py-2.5 text-sm text-slate-700">{p.casNumber}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                 
                </>
              )}
            </motion.div>
          </div>


          <div className="mt-10 rounded-3xl border border-slate-200 bg-white p-7">
            <div className="font-extrabold text-slate-900">Don’t see what you need?</div>
            <p className="mt-2 text-sm sm:text-[16px] text-slate-600 leading-relaxed">
              We support custom synthesis and API development based on your requirements.
            </p>
            <a
              href="/contact"
              className="mt-5 inline-flex items-center justify-center rounded-2xl bg-brand-primary text-white px-5 py-3 font-semibold hover:brightness-110 transition"
            >
              Enquire for Custom Synthesis
            </a>
          </div>
        </div>
      </section>
    </PageLayout>
  )
}


